import PostReaction from './PostReaction';

export const models = {
  PostReaction,
};
